import React, { Component } from 'react';
import { Modal } from 'antd';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';

const SortableItem = SortableElement(({ value }) =>
    <div className="sortgrid-item">
        <div className="sortitem">
            {value.milestoneNode}
        </div>
    </div>
);

const SortableList = SortableContainer(({ data }) => {
    return (
        <div className='degreesort'>
            {data.map((item, index) => (
                <SortableItem key={`item-${index}`} index={index} value={item} />
            ))}
        </div>
    );
});

class SortOrder extends Component {
    state = {
        visible: false,
        data: [],
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        const { data } = this.state;
        this.setState({
            data: arrayMove(data, oldIndex, newIndex),
        });
    }

    show = (data) => {
        this.setState({
            visible: true,
            data
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    confirm = () => {
        const { data } = this.state;
        this.props.onSort(data);
        this.hide();
    }

    render() {
        const { data, visible, loading } = this.state;
        return (
            <Modal
                title="调整顺序"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
                width="500px"
                confirmLoading={loading}
            >
                <div>
                    <SortableList data={data} axis="xy" helperClass="sortHelper" onSortEnd={this.onSortEnd} />
                </div>
            </Modal>
        );
    }
}

export default SortOrder;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Payment/Components/SortOrder.js